/**
 * Operator-facing wording for an Iris escalation trigger.
 *
 * The backend keeps ai-operations' raw trigger names (HUMAN_REQUEST, …); the
 * inbox shows what the customer actually did so an operator can triage the
 * "Escalated" section at a glance. An unknown trigger falls back to its raw
 * name in title case rather than hiding the chip.
 */
const TRIGGER_LABELS: Record<string, string> = {
  HUMAN_REQUEST: 'Asked for a person',
  NEGATIVE_SENTIMENT: 'Upset customer',
  PRICING: 'Pricing question',
  NO_SLOTS: 'No availability',
  LOW_CONFIDENCE: 'Iris got stuck',
  RESCHEDULE_THRESHOLD: 'Repeated reschedules',
  EMAIL_LOOP: 'Possible email loop',
};

export function escalationLabel(trigger: string | null | undefined): string {
  if (!trigger) return 'Needs a human';
  const known = TRIGGER_LABELS[trigger];
  if (known) return known;
  return trigger
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((word, i) => (i === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ');
}
